import styled from 'styled-components'

export const ExploreWrapper = styled.main`
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 100dvw;
`

export const ExploreHeader = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 4rem 1rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    gap: 1.5rem;
  }
`

export const ExploreTitle = styled.h1`
  color: black;
  font-size: 38px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: 0.38px;
  word-wrap: break-word;
  margin: 0;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 40px;
    letter-spacing: 0.28px;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 36px;
  }
`

export const ExploreSubtext = styled.p`
  color: #212d40;
  font-size: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  letter-spacing: 0.2px;
  word-wrap: break-word;
  margin: 0;
  text-align: center;
  width: 100%;
  line-height: 1.6;
  max-width: 1000px;

  @media (max-width: 768px) {
    font-size: 16px;
    letter-spacing: 0.16px;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`

export const CTAButtonContainer = styled.div`
  position: relative;
  width: 348px;
  height: 50px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 280px;
    height: 44px;
  }

  @media (max-width: 480px) {
    width: 240px;
    height: 40px;
  }
`

export const CTAButtonBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37%, #ff4f7e 75%, #ff6d90 100%);
  border-radius: 83px;
`

export const CTAButton = styled.button`
  width: 100%;
  height: 100%;
  position: relative;
  background: transparent;
  border: none;
  border-radius: 83px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  word-wrap: break-word;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(255, 79, 126, 0.3);
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`

export const SortingSection = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 1rem 0;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
`

export const SortingControls = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;

  @media (max-width: 768px) {
    align-self: flex-start;
  }
`

export const SortLabel = styled.span`
  color: #4e4e4e;
  font-size: 16px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  letter-spacing: 0.16px;
  word-wrap: break-word;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const SortDropdown = styled.select`
  width: 104px;
  height: 42px;
  background: white;
  border-radius: 10px;
  border: 1px solid #7a7a7a;
  padding: 0 12px;

  color: #424242;
  font-size: 14px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  letter-spacing: 0.14px;
  cursor: pointer;

  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23424242' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 16px;

  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;

  &:hover {
    border-color: #5a5a5a;
  }

  &:focus {
    outline: none;
    border-color: #ff5e6d;
    box-shadow: 0 0 0 2px rgba(255, 94, 109, 0.2);
  }

  @media (max-width: 768px) {
    width: 120px;
    height: 36px;
    font-size: 12px;
    padding: 0 8px;
  }

  @media (max-width: 480px) {
    width: 80px;
    height: 32px;
    font-size: 11px;
    padding: 0 6px;
  }
`

export const SectionTitle = styled.h2`
  color: black;
  font-size: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  word-wrap: break-word;
  margin: 0;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 18px;
    text-align: left;
  }
`

export const ExploreFooter = styled.footer`
  width: 100%;
  z-index: 1;
  margin: -12rem auto 0;
  padding: 18rem 1rem 4rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    margin: -8rem auto 0;
    padding: 12rem 1.5rem 3.5rem;
  }

  @media (max-width: 768px) {
    margin: 0 auto;
    padding: 6rem 1rem 3rem;
    gap: 1.75rem;
  }

  @media (max-width: 480px) {
    padding: 5rem 1rem 2.5rem;
    gap: 1.5rem;
  }
`

export const FooterBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.49) 17%, white 48%);
  pointer-events: none;
  z-index: -1;

  @media (max-width: 768px) {
    top: -4rem;
    height: 160%;
  }
`

export const FooterContent = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    max-width: 760px;
  }

  @media (max-width: 768px) {
    max-width: 343px;
    width: 100%;
    margin: 0 auto;
    gap: 1.75rem;
    align-items: stretch;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    gap: 1.5rem;
  }
`

export const FooterCopyGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    align-items: flex-start;
    gap: 1rem;
  }
`

export const FooterActions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    gap: 1.25rem;
  }
`

export const FooterTitle = styled.h2`
  color: black;
  font-size: 40px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  line-height: 1.2;
  word-wrap: break-word;
  margin: 0;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 26px;
    line-height: 36px;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 28px;
  }
`

export const FooterSubtext = styled.p`
  color: black;
  font-size: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  line-height: 1.6;
  word-wrap: break-word;
  margin: 0;
  text-align: center;
  width: 70%;
  max-width: 760px;

  @media (max-width: 1024px) {
    width: 80%;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    letter-spacing: 0.16px;
    text-align: left;
    width: 100%;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    letter-spacing: 0.14px;
  }
`

export const FooterCTAText = styled.div`
  color: black;
  font-size: 30px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  line-height: 1.2;
  word-wrap: break-word;
  margin: 0;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 22px;
    text-align: left;
    line-height: 32px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    line-height: 28px;
  }
`

export const FooterCTAButtonContainer = styled.div`
  position: relative;
  width: 279px;
  height: 50px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 240px;
    height: 44px;
  }

  @media (max-width: 480px) {
    width: 180px;
    height: 42px;
  }
`

export const FooterCTAButtonBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37%, #ff4f7e 75%, #ff6d90 100%);
  border-radius: 83px;
`

export const FooterCTAButton = styled.button`
  width: 100%;
  height: 100%;
  position: relative;
  background: transparent;
  border: none;
  border-radius: 83px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  word-wrap: break-word;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(255, 79, 126, 0.3);
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`

export const FooterLoginText = styled.div`
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  margin: 0;

  .login-prompt {
    color: black;
    font-size: 18px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 500;
    word-wrap: break-word;
    margin: 0;
  }

  .login-link {
    color: #ff5e6d;
    font-size: 18px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 500;
    text-decoration: underline;
    word-wrap: break-word;
    cursor: pointer;
    margin: 0;
    background: none;
    border: none;
    padding: 0;
    transition: color 0.2s ease;

    &:hover {
      color: #ff4f7e;
    }
  }

  @media (max-width: 768px) {
    .login-prompt,
    .login-link {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    .login-prompt,
    .login-link {
      font-size: 14px;
    }

    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
  }
`

export const LoadMoreButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin: 2rem auto;
  display: block;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`

export const SignupWall = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 3rem 2rem;
  border-radius: 12px;
  text-align: center;
  margin: 2rem auto;
  max-width: 600px;

  @media (max-width: 768px) {
    margin: 2rem 1rem;
    padding: 2rem 1.5rem;
  }

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
  }

  p {
    font-size: 1rem;
    margin-bottom: 2rem;
    opacity: 0.9;

    @media (max-width: 768px) {
      font-size: 0.9rem;
      margin-bottom: 1.5rem;
    }
  }

  button {
    background: white;
    color: #667eea;
    border: none;
    padding: 1rem 2rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s ease;

    @media (max-width: 768px) {
      padding: 0.875rem 1.5rem;
      font-size: 0.9rem;
    }

    &:hover {
      transform: translateY(-1px);
    }
  }
`

export const MobileGrid = styled.div`
  @media (max-width: 768px) {
    .feed-container {
      ${props =>
        !props.isAuthenticated
          ? `
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0.5rem;
        padding: 0 0.5rem;
      `
          : `
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0 1rem;
      `}
    }
  }
`

export const FloatingCta = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: #667eea;
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 50px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  z-index: 1000;

  @media (max-width: 768px) {
    bottom: 1rem;
    right: 1rem;
    padding: 0.75rem 1.25rem;
    font-size: 0.9rem;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4);
  }
`

export const AdContainer = styled.div`
  width: 100%;
  text-align: center;
  margin: 2rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e1e5e9;

  a {
    display: inline-block;
    padding: 1rem 2rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-weight: 600;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }

  @media (max-width: 768px) {
    margin: 1.5rem 0;
    padding: 0.75rem;

    a {
      padding: 0.875rem 1.5rem;
      font-size: 0.9rem;
    }
  }
`
